export default {
    common: {
        ok: 'OK',
        cancel: 'Cancel',
        save: 'Save',
        delete: 'Delete',
        edit: 'Edit',
        close: 'Close',
        confirm: 'Confirm',
        back: 'Back',
        next: 'Next',
        apply: 'Apply',
        done: 'Done',
        loading: 'Loading...',
        error: 'Error',
        success: 'Success',
        warning: 'Warning',
        info: 'Info'
    },
    navbar: {
        home: 'Home',
        history: 'History',
        settings: 'Settings',
        profile: 'Profile',
        vacation: 'Vacation',
        scanner: {
            checkIn: 'Check In',
            bleCheckIn: 'BLE Check In',
            checkingLocation: 'Checking Location...',
            locationRequired: 'Location Required'
        }
    },
    settings: {
        title: 'Settings',
        notifications: {
            title: 'Notifications',
            checkInReminders: 'Check-in Reminders',
            checkInRemindersDesc: 'Remind me to check in before work starts',
            checkOutReminders: 'Check-out Reminders',
            checkOutRemindersDesc: 'Remind me to check out after work ends',
            reminderTime: 'Reminder Time',
            reminderTimeDesc: 'How far in advance to send reminders',
            updated: {
                checkIn: 'Check-in reminders updated',
                checkOut: 'Check-out reminders updated',
                time: 'Reminder time updated'
            }
        },
        bleAttendance: {
            title: 'Bluetooth Attendance',
            enableLabel: 'Enable BLE Attendance',
            enableDesc: 'Automatically detect Bluetooth device for attendance check-in',
            enabled: 'Bluetooth attendance enabled',
            disabled: 'Bluetooth attendance disabled',
            permissionDenied: 'Bluetooth permissions denied. Please enable in device settings.',
            updateFailed: 'Failed to update Bluetooth setting'
        },
        reminder: {
            minutesBefore: 'Minutes before',
            minutesAfter: 'Minutes after',
            minutes: {
                one: '1 minute',
                other: '{count} minutes'
            }
        },
        appearance: {
            title: 'Appearance',
            theme: 'Theme',
            themeDesc: 'Choose your preferred color theme',
            themeOptions: {
                light: 'Light',
                dark: 'Dark',
                auto: 'Auto (System)'
            },
            themeChanged: 'Theme changed to {theme}'
        },
        language: {
            title: 'Language',
            language: 'Language',
            languageDesc: 'Choose your preferred language',
            languageChanged: 'Language changed to {language}'
        },
        profile: {
            title: 'Profile',
            workerId: 'Worker ID',
            name: 'Name',
            lastSync: 'Last Sync',
            notAssigned: 'Not assigned',
            unknown: 'Unknown',
            never: 'Never'
        },
        reminderTimeOptions: {
            minutes5: '5 minutes',
            minutes10: '10 minutes',
            minutes15: '15 minutes',
            minutes30: '30 minutes',
            hour1: '1 hour'
        }
    },
    dashboard: {
        title: 'Dashboard',
        checkIn: 'Check In',
        checkOut: 'Check Out',
        welcome: 'Welcome',
        currentStatus: 'Current Status',
        todayAttendance: 'Today Attendance',
        totalDays: 'Total Days',
        comingSoon: 'Coming soon',
        duration: 'Duration',
        shortDuration: 'Short',
        onTrack: 'On track',
        working: 'Working...',
        durationComplete: 'Complete',
        notCheckedIn: 'Not checked in',
        notYet: 'Not yet',
        completed: 'Completed',
        onTime: 'On Time',
        late: 'Late',
        early: 'Early',
        missingCheckOut: 'Missing Check-out',
        manualEntry: 'Manual Entry',
        vacationUsed: 'Used',
        vacationLeft: 'Left',
        attendanceRegistered: 'Attendance registered',
        qrValidated: 'QR Code Validated',
        bleValidated: 'Bluetooth Validated',
        processingBleCheckin: 'Processing Bluetooth check-in...',
        logout: {
            confirm: 'Confirm Logout',
            message:
                'Are you sure you want to logout? You will need to re-assign your worker profile.',
            cancel: 'Cancel',
            button: 'Logout'
        }
    },
    history: {
        title: 'History',
        noRecords: 'No attendance records found',
        checkInTime: 'Check-in',
        checkOutTime: 'Check-out',
        labels: {
            duration: 'Duration',
            location: 'Location',
            qrCode: 'QR Code',
            geofence: 'Geofence'
        },
        viewToggle: {
            calendar: 'Calendar',
            list: 'List'
        },
        loading: 'Loading attendance history...',
        error: 'Failed to load attendance history. Please try again.',
        retry: 'Retry',
        emptyState: 'No attendance records for this period.',
        validated: 'Validated',
        notValidated: 'Not Validated',
        calendar: {
            prevMonth: 'Previous month',
            nextMonth: 'Next month',
            viewDetailsAtTime: 'View details for {time}'
        },
        status: {
            holiday: 'Holiday',
            absence: 'Absence'
        }
    },
    scanner: {
        title: 'QR Scanner',
        scanning: 'Scanning...',
        scanSuccess: 'Scan successful',
        scanError: 'Scan failed'
    },
    profile: {
        title: 'Profile',
        assignWorker: 'Assign Worker'
    },
    admin: {
        title: 'Admin Panel',
        accessDenied: 'Access denied',
        subtitle: 'Administrative Access - Use with Caution',
        banner: {
            title: 'ADMIN MODE ACTIVE',
            description: 'Debug settings and administrative functions are enabled. Use with caution.'
        },
        debug: {
            banner: {
                title: 'FOR TESTING ONLY',
                desc: 'Debug modes bypass security checks. Disable before production use.'
            },
            bypass: {
                title: 'Bypass Geofence Check',
                desc: 'Allow check-in/check-out from any location'
            },
            staticQr: {
                title: 'Allow Static QR Code',
                desc: 'Accept predefined test QR code (never expires)'
            },
            lastModified: 'Last modified:',
            time: {
                never: 'Never',
                justNow: 'Just now',
                minutes: {
                    one: '1 minute ago',
                    other: '{count} minutes ago'
                },
                hours: {
                    one: '1 hour ago',
                    other: '{count} hours ago'
                }
            }
        },
        prompt: {
            title: 'Admin Authentication',
            description: 'Enter the admin password to continue',
            passwordLabel: 'Password',
            passwordPlaceholder: 'Enter admin password',
            unlock: 'Unlock Admin',
            accessGranted: 'Admin access granted',
            incorrectPassword: 'Incorrect password',
            authFailed: 'Authentication failed',
            lockedTitle: 'Account Locked',
            attemptsRemaining: '{count} attempt(s) remaining',
            errors: {
                required: 'Password is required',
                lockedOut: 'Too many failed attempts. Try again in {minutes} minute(s).'
            }
        },
        alerts: {
            exit: {
                header: 'Exit Admin Mode',
                message:
                    'Are you sure you want to exit admin mode? You will need to use the gesture again to re-enter.',
                confirm: 'Exit Admin'
            },
            forget: {
                header: 'Forget Worker',
                message:
                    "Are you sure you want to forget this worker? This will clear all local data and return the app to its initial state. This action cannot be undone.",
                confirm: 'Forget Worker'
            },
            resetBundle: {
                header: 'Reset App Bundle',
                message: 'This will reset the app to the built-in version. The app will close and you will need to reopen it manually.',
                confirm: 'Reset & Close'
            }
        },
        cards: {
            manualRecords: {
                title: 'Manual Records',
                value: 'Manage Attendance',
                status: 'Create, edit, and delete records',
                open: 'Open Manual Records'
            },
            logs: {
                title: 'System Logs',
                value: 'View Activity & Security',
                status: 'Activity logs and security monitoring',
                open: 'Open Logs'
            },
            worker: {
                title: 'Current Worker',
                noWorker: 'No worker assigned',
                id: 'ID',
                assignToContinue: 'Assign a worker to continue',
                forget: 'Forget Worker',
                workerIdMissing: 'Worker ID not found',
                forgotten: 'Worker forgotten. All local data cleared.'
            },
            settings: {
                title: 'Settings',
                value: 'Configure',
                status: 'App settings and debug options',
                open: 'Open Settings'
            },
            system: {
                title: 'System',
                value: 'Refresh',
                status: 'Data and system status',
                refreshButton: 'Refresh Data',
                refreshing: 'Refreshing all data...',
                refreshed: 'All data refreshed successfully!',
            refreshFailed: 'Failed to refresh data',
            checkSyncStatus: 'Check Sync Status',
            forceMarkPending: 'Force Mark as Pending',
            toasts: {
                syncStatus: "Today: {today} ({pendingToday} pending)\nTotal pending: {totalPending}",
                syncStatusFailed: 'Failed to check sync status',
                noRecordsToday: 'No records found for today',
                markedPending: 'Marked {count} record(s) as pending. Use "Refresh Data" to sync.',
                markPendingFailed: 'Failed to mark records as pending'
            }
            },
            schedule: {
                title: 'Work Schedule',
                type: 'Type',
                duration: 'Duration',
                checkIn: 'Check-in',
                checkOut: 'Check-out',
                before: 'before',
                after: 'after',
                maxOffsetStart: 'Max offset start',
                minOffsetEnd: 'Min offset end',
                days: 'Days'
            },
            notifications: {
                title: 'Notifications',
                value: 'Test',
                status: 'Send test notification',
                send: 'Send Test',
                sent: 'Test notification sent! Check your notification tray.',
                sendFailed: 'Failed to send test notification'
            },
            session: {
                started: 'Admin Session Started'
            },
            version: {
                title: 'App Version',
                web: 'Web',
                native: 'Native'
            }
        },
        geofence: {
            title: 'Geofence Map Viewer',
            status: {
                inside: 'Inside Geofence',
                outside: 'Outside Geofence',
                unknown: 'Unknown'
            },
            accuracy: {
                label: 'GPS Accuracy',
                meters: 'meters',
                na: 'N/A'
            },
            error: 'Error:',
            legend: {
                title: 'Legend',
                boundary: 'Geofence Boundary',
                currentLocation: 'Current Location'
            }
        },
        totp: {
            title: 'TOTP Secret Configuration',
            subtitle: 'Configure the shared secret for QR code validation',
            status: {
                status: 'Status:',
                configured: 'Configured',
                notConfigured: 'Not Configured',
                lastSynced: 'Last Synced:',
                secretLength: 'Secret Length:',
                characters: '{chars} characters'
            },
            info: {
                howTo: 'How to configure:',
                scanTitle: 'Scan QR Code:',
                scanDesc: 'Use the scanner below to scan from your Generator app',
                manualTitle: 'Manual Entry:',
                manualDesc: 'Enter the Base32 secret directly',
                note: 'Both apps must use the same secret for validation to work.'
            },
            scan: {
                title: 'Scan QR Code from Generator',
                desc: 'Scan any QR code from your Generator app to automatically extract and save the secret.',
                open: 'Open QR Scanner',
                modalTitle: 'Scan QR Code',
                instructions: 'Position the QR code from your Generator app within the frame'
            },
            manual: {
                title: 'Manual Secret Entry',
                placeholder: 'Enter Base32 secret (e.g., JBSWY3DPEHPK3PXP)'
            },
            validation: {
                invalidFormat: 'Invalid format. Use only A-Z and 2-7 characters.',
                tooShort: 'Secret too short. Minimum 16 characters recommended.',
                valid: 'Valid Base32 format'
            },
            actions: {
                save: 'Save Secret',
                update: 'Update Secret',
                clear: 'Clear Secret'
            },
            viewCurrent: 'View Current Secret',
            modal: {
                currentTitle: 'Current TOTP Secret',
                keepSecure: 'Keep this secret secure! Anyone with this secret can generate valid tokens.',
                copy: 'Copy to Clipboard'
            },
            test: {
                title: 'Test TOTP Generation',
                desc: 'Generate a token to verify your secret is working correctly. This token should match the one shown in your Generator app.',
                generate: 'Generate Test Token',
                currentToken: 'Current Token:',
                validFor: 'Valid for {seconds}s'
            },
            alert: {
                clear: {
                    header: 'Clear TOTP Secret?',
                    message: "This will remove the stored secret. You'll need to reconfigure it by scanning a QR code or entering it manually.",
                    confirm: 'Clear'
                }
            },
            toast: {
                saved: 'TOTP secret saved successfully',
                saveFailed: 'Failed to save secret',
                cleared: 'TOTP secret cleared',
                clearFailed: 'Failed to clear secret',
                loadFailed: 'Failed to load secret',
                copySuccess: 'Secret copied to clipboard',
                copyFailed: 'Failed to copy secret',
                openScannerFailed: 'Failed to open scanner',
                generateFailed: 'Failed to generate token',
                noSecret: 'No secret configured',
                scanSaved: 'Secret scanned and saved successfully ({length} characters)',
                invalidQR: 'Invalid QR code format',
                scanFailed: 'Scan failed: {error}'
            }
        },
        manualRecords: {
            pageTitle: 'Manual Record Management',
            labels: {
                worker: 'Worker',
                month: 'Month'
            },
            actions: {
                create: 'Create Manual Record'
            },
            loading: 'Loading records...',
            empty: 'No attendance records found for this month.',
            status: {
                inProgress: 'In Progress',
                checkedIn: 'Checked In',
                checkedOut: 'Checked Out',
                incomplete: 'Incomplete'
            },
            edit: {
                title: 'Edit Attendance Record',
                info: 'Edit the check-in and check-out times. Status will be calculated automatically based on work schedule.',
                update: 'Update Record'
            },
            create: {
                title: 'Create Manual Record',
                create: 'Create Record'
            },
            fields: {
                date: 'Date',
                checkIn: 'Check-in Time',
                checkOut: 'Check-out Time',
                checkOutOptional: 'Check-out Time (optional)',
                status: 'Status'
            },
            delete: {
                header: 'Delete Record',
                message: 'Are you sure you want to delete this attendance record? This action cannot be undone.'
            },
            toasts: {
                loaded: 'Loaded {count} records',
                loadFailed: 'Failed to load records',
                updated: 'Record updated successfully',
                updateFailed: 'Failed to update record',
                created: 'Manual record created successfully',
                createFailed: 'Failed to create record',
                deleted: 'Record deleted successfully',
                deleteFailed: 'Failed to delete record'
            }
        }
    },
    manualRecords: {
        pageTitle: 'Manual Record Management',
        labels: {
            worker: 'Worker',
            month: 'Month'
        },
        actions: {
            create: 'Create Manual Record'
        },
        loading: 'Loading records...',
        empty: 'No attendance records found for this month.',
        status: {
            inProgress: 'In Progress',
            checkedIn: 'Checked In',
            checkedOut: 'Checked Out',
            incomplete: 'Incomplete'
        },
        edit: {
            title: 'Edit Attendance Record',
            info: 'Edit the check-in and check-out times. Status will be calculated automatically based on work schedule.',
            update: 'Update Record'
        },
        create: {
            title: 'Create Manual Record',
            create: 'Create Record'
        },
        fields: {
            date: 'Date',
            checkIn: 'Check-in Time',
            checkOut: 'Check-out Time',
            checkOutOptional: 'Check-out Time (optional)',
            status: 'Status'
        },
        delete: {
            header: 'Delete Record',
            message: 'Are you sure you want to delete this attendance record? This action cannot be undone.'
        },
        toasts: {
            loaded: 'Loaded {count} records',
            loadFailed: 'Failed to load records',
            updated: 'Record updated successfully',
            updateFailed: 'Failed to update record',
            created: 'Manual record created successfully',
            createFailed: 'Failed to create record',
            deleted: 'Record deleted successfully',
            deleteFailed: 'Failed to delete record'
        }
    },
    components: {
        attendanceCard: {
            inProgress: 'In progress'
        },
        geofenceCard: {
            location: 'Location',
            atOffice: 'At Office',
            outside: 'Outside',
            verifying: 'Verifying...',
            checking: 'Checking location...',
            youAreInside: 'You are inside',
            needToBeInside: 'Need to be inside to check in/out'
        },
        qrFeedback: {
            titles: {
                validated: 'QR Code Validated',
                locationFailed: 'Location Verification Failed',
                validationFailed: 'Validation Failed'
            },
            messages: {
                success: 'QR code has been validated successfully!',
                locationErrorDefault:
                    'Location verification failed. Stay inside office boundary.',
                failedDefault: 'QR code validation failed. Please try again.'
            },
            actions: {
                tryAgain: 'Try Again',
                cancel: 'Cancel'
            }
        }
    },
    scannerView: {
        ui: {
            initializing: 'Initializing scanner...',
            notSupportedTitle: 'Scanner Not Supported',
            notSupportedMessage: 'QR scanning is not available on this device.',
            verifyingLocation: 'Verifying Location...',
            locationRequired: 'Location Required',
            startStartingTitle: 'Starting Scanner...',
            preparingCamera: 'Preparing camera for QR code detection',
            startScanButton: 'Start Scanning',
            verifyLocationButton: 'Verify Location',
            cancel: 'Cancel',
            toggleFlashAria: 'Toggle flashlight',
            debugPrefix: 'Debug: locationStatus = "{status}"'
        },
        alerts: {
            scannerErrorTitle: 'Scanner Error',
            ok: 'OK',
            locationRequiredTitle: 'Location Required',
            locationRequiredMessage:
                'You must be inside the office boundary to scan QR codes.'
        },
        toasts: {
            notSupported: 'QR scanning is not supported on this device',
            genericError: 'Scanner error. Please try again.'
        },
        errors: {
            timeout:
                'Location request timed out. Please ensure GPS is enabled and try again.',
            failedOpenCamera: 'Failed to open camera scanner',
            failedScan: 'Failed to scan QR code'
        },
        location: {
            insideReady: 'Location verified. Ready to scan.',
            outsideBoundary: 'You must be inside the office boundary to scan QR codes.',
            poorAccuracy: 'GPS accuracy is low. Move to an open area.',
            gpsUnavailable: 'GPS signal required. Move to an open area.',
            permissionRequired: 'Location permission required.',
            checking: 'Checking location...',
            verificationRequired: 'Location verification required.'
        },
        headerTitle: 'QR Scanner'
    },
    notifications: {
        checkIn: {
            before: {
                title: 'Time to Check In',
                body: "Don't forget to check in when you arrive at the office"
            },
            after: {
                title: 'You Forgot to Check In',
                body: "You haven't checked in yet. Please check in as soon as possible"
            }
        },
        checkOut: {
            before: {
                title: 'Time to Check Out',
                body: "Don't forget to check out before leaving the office"
            },
            after: {
                title: 'You Forgot to Check Out',
                body: "You haven't checked out yet. Please check out now"
            }
        },
        test: {
            title: 'Test Notification',
            body: 'This is a test notification from Warden Admin Panel'
        },
        settings: {
            checkInBeforeLabel: 'Check-in reminder (before)',
            checkInBeforeDesc: 'Remind me before work starts',
            checkInAfterLabel: 'Check-in reminder (after)',
            checkInAfterDesc: 'Remind me if I forgot to check in',
            checkOutBeforeLabel: 'Check-out reminder (before)',
            checkOutBeforeDesc: 'Remind me before work ends',
            checkOutAfterLabel: 'Check-out reminder (after)',
            checkOutAfterDesc: 'Remind me if I forgot to check out'
        }
    },
    logViewer: {
        title: 'Logs',
        search: 'Search logs...',
        filters: {
            title: 'Filters',
            active: 'Active',
            category: 'Category',
            level: 'Level',
            type: 'Type',
            dateRange: 'Date Range',
            startDate: 'Start Date',
            endDate: 'End Date',
            clearFilters: 'Clear Filters'
        },
        categories: {
            all: 'All Categories',
            sync: 'Sync',
            auth: 'Auth',
            location: 'Location',
            qr: 'QR',
            ble: 'BLE',
            api: 'API',
            admin: 'Admin',
            system: 'System',
            security: 'Security'
        },
        levels: {
            all: 'All Levels',
            debug: 'Debug',
            info: 'Info',
            warn: 'Warning',
            error: 'Error'
        },
        securityTypes: {
            all: 'All Types',
            invalid_qr: 'Invalid QR',
            expired_qr: 'Expired QR',
            replay_attempt: 'Replay Attack',
            geofence_failure: 'Geofence Failure',
            repeated_failure: 'Repeated Failures'
        },
        actions: {
            export: 'Export',
            clear: 'Clear Logs',
            refresh: 'Refresh',
            viewDetails: 'View Details',
            hideDetails: 'Hide Details'
        },
        states: {
            loading: 'Loading logs...',
            empty: 'No logs found',
            emptyFiltered: 'No logs match the current filters',
            emptyActivity: 'No activity logs yet',
            emptySecurity: 'No suspicious activity detected'
        },
        details: {
            title: 'Log Details',
            timestamp: 'Timestamp',
            level: 'Level',
            category: 'Category',
            message: 'Message',
            context: 'Additional Details',
            workerId: 'Worker ID',
            location: 'Location',
            failureReason: 'Failure Reason',
            attemptCount: 'Attempts',
            syncStatus: 'Sync Status',
            isPermanent: 'Permanent Record'
        },
        badges: {
            suspicious: 'SUSPICIOUS',
            permanent: 'PERMANENT'
        },
        count: {
            total: '{count} logs',
            suspicious: '{count} suspicious'
        },
        alerts: {
            clearTitle: 'Clear All Logs',
            clearMessage: 'Are you sure you want to delete all logs? This action cannot be undone.',
            clearConfirm: 'Clear Logs',
            clearSecurityTitle: 'Clear Security Logs',
            clearSecurityMessage: 'Are you sure you want to delete all security logs? This action cannot be undone.'
        },
        toasts: {
            exported: 'Logs exported successfully',
            exportFailed: 'Failed to export logs',
            cleared: 'All logs have been cleared',
            clearFailed: 'Failed to clear logs',
            refreshed: 'Logs refreshed',
            refreshFailed: 'Failed to refresh logs'
        }
    },
    profileAssignment: {
        noUser: {
            title: 'User is not set',
            message: 'Please contact the administrator to set up this device.',
            adminAccess: 'Administrator Access'
        },
        auth: {
            authenticating: 'Authenticating...'
        },
        workerSelection: {
            title: 'Assign Worker to Device',
            subtitle: 'Select the worker who will use this device',
            loading: 'Loading workers...',
            searchPlaceholder: 'Search workers by name or ID...',
            workersFound: '{count} worker(s) found',
            selectedWorker: 'Selected Worker:',
            workerId: 'ID: {id}',
            noResults: 'No workers found matching "{query}"',
            assignButton: 'Assign Worker to Device',
            selectWorker: 'Please select a worker'
        },
        errors: {
            connectionError: 'Unable to connect to server. Please check your connection.',
            loadWorkersFailed: 'Failed to load workers. Please try again.',
            invalidPassword: 'Invalid admin password. Please try again.',
            authFailed: 'Authentication failed. Please try again.',
            workerNotFound: 'Worker not found. Please contact IT support.',
            assignmentFailed: 'Failed to authenticate worker. Please try again.'
        }
    },
    vacation: {
        title: 'Vacation',
        summary: 'Vacation info',
        paidRemaining: 'Available now',
        perYear: 'Annual accrual',
        atYearStart: 'On Jan 1',
        unpaidUsed: 'Unpaid used',
        history: 'History',
        from: 'From',
        to: 'to',
        adjustment: 'Adjustment',
        noHistory: 'No records found',
        types: {
            VACATION: 'Vacation',
            WORKING_HOLIDAY: 'Working holiday',
            ADJUSTMENT: 'Adjustment',
        },
        d: 'd',
        h: 'h',
        error: 'Failed to load vacation data. Please try again.',
        retry: 'Retry'
    },
    update: {
        title: 'Update Available',
        whatsNew: "What's New",
        updateApp: 'Update App',
        installNewVersion: 'Install New Version',
        later: 'Later',
        downloadingBundle: 'Downloading update...',
        downloadingApk: 'Downloading installer...',
        downloadFailed: 'Download failed. Please try again.',
        apkInstallHint: 'You will be prompted to install the update.',
        readyToRestart: 'Update downloaded successfully! Restart the app to apply the new version.',
        restartNow: 'Restart Now'
    }
}
